import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)

class DialogUtils {
    public static showErrorDialog(message: string) {
        MySwal.fire({
            title: 'Solicitud no procesada',
            html: `<p class="px-1 py-2">${message}</p>`,
            icon: 'error',
            customClass: {
                popup: 'swal-popup-custom',
                title: 'swal-title-small',
                icon: 'swal-icon-small',
                htmlContainer: 'swal-html-large',
            },
        })
    }

    public static showSuccesDialog(message: string) {
        MySwal.fire({
            title: 'Solicitud procesada',
            html: `<p class="px-1 py-2">${message}</p>`,
            icon: 'success',
            customClass: {
                popup: 'swal-popup-custom',
                title: 'swal-title-small',
                icon: 'swal-icon-small',
                htmlContainer: 'swal-html-large',
            },
        })
    }
}

export default DialogUtils
